import type { FormFlow, FmpFormStep } from '../../../types/form'
import { FormTypeEnum } from '@strata-monorepo/shared-types'
import { addressAndMover } from '../questions/addressAndMover'
import { energyPlanIncludes } from '../questions/energyPlanIncludes'
import { homeInfo } from '../questions/homeInfo'
import { householdIncludes } from '../questions/householdIncludes'
import { monthlyEnergy } from '../questions/monthlyEnergy'
import { texasMove } from '../questions/texasMove'
import { termChoice } from '../questions/termChoice'
import { uploadBill } from '../questions/uploadBill'
import { vehicleCharge } from '../questions/vehicleCharge'

export const FMP_FORM_NAME = 'fmp_v1'

export const createLongQuiz = (): FormFlow => {
  // Overrides
  const addressAndMoverQuestion = {
    ...addressAndMover,
    componentProps: {
      ...addressAndMover.componentProps,
      shouldFetchConsumptionPrediction: false,
    },
  }

  const homeInfoQuestion = {
    ...homeInfo,
    componentProps: {
      ...homeInfo.componentProps,
      shouldFetchConsumptionPrediction: false,
    },
  }
  const texasMoveQuestion = {
    ...texasMove,
    componentProps: {
      ...texasMove.componentProps,
      tracking: {
        ...texasMove.componentProps.tracking,
        deepStepNumber: 2,
        quickStepNumber: 2,
        deepStepId: '2',
        quickStepId: '2',
      },
    },
  }

  const monthlyEnergyQuestion = {
    ...monthlyEnergy,
    coreIf: true,
    visibleIf: undefined,
    componentProps: {
      ...monthlyEnergy.componentProps,
      tracking: {
        ...monthlyEnergy.componentProps.tracking,
        deepStepNumber: 3,
        quickStepNumber: 3,
        deepStepId: '3',
        quickStepId: '3',
      },
    },
  }

  const householdIncludesQuestion = {
    ...householdIncludes,
    coreIf: true,
    visibleIf: undefined,
    componentProps: {
      ...householdIncludes.componentProps,
      tracking: {
        ...householdIncludes.componentProps.tracking,
        deepStepNumber: 4,
        quickStepNumber: 4,
        deepStepId: '4',
        quickStepId: '4',
      },
    },
  }

  const vehicleChargeQuestion = {
    ...vehicleCharge,
    coreIf: {
      operator: '&&',
      conditions: [
        {
          formStepKey: 'householdIncludes',
          comparisonOperator: 'includes',
          expectedAnswer: 'electricVehicle',
        },
      ],
    },
    componentProps: {
      ...vehicleCharge.componentProps,
      tracking: {
        ...vehicleCharge.componentProps.tracking,
        deepStepNumber: 5,
        quickStepNumber: 5,
        deepStepId: '5',
        quickStepId: '5',
      },
    },
  }

  const energyPlanIncludesQuestion = {
    ...energyPlanIncludes,
    componentProps: {
      ...energyPlanIncludes.componentProps,
      tracking: {
        ...energyPlanIncludes.componentProps.tracking,
        deepStepNumber: 6,
        quickStepNumber: 6,
        deepStepId: '6',
        quickStepId: '6',
      },
    },
  }

  const termChoiceQuestion = {
    ...termChoice,
    coreIf: true,
    visibleIf: undefined,
    componentProps: {
      ...termChoice.componentProps,
      tracking: {
        ...termChoice.componentProps.tracking,
        deepStepNumber: 7,
        quickStepNumber: 7,
        deepStepId: '7',
        quickStepId: '7',
      },
    },
  }

  const uploadBillQuestion = {
    ...uploadBill,
    visibleIf: undefined,
    componentProps: {
      ...uploadBill.componentProps,
      tracking: {
        ...uploadBill.componentProps.tracking,
        deepStepNumber: 8,
        quickStepNumber: 8,
        deepStepId: '8',
        quickStepId: '8',
      },
    },
  }

  const longQuizQuestions: FmpFormStep[] = [
    addressAndMoverQuestion,
    homeInfoQuestion,
    texasMoveQuestion,
    monthlyEnergyQuestion,
    householdIncludesQuestion,
    vehicleChargeQuestion,
    energyPlanIncludesQuestion,
    termChoiceQuestion,
    uploadBillQuestion,
  ]

  /**
   * The main form flow configuration for Find My Plan
   * Contains version information and all questionnaire steps
   */
  return {
    version: FMP_FORM_NAME,
    questions: longQuizQuestions,
    formType: FormTypeEnum.LONG_FORM,
    progressDisplay: { mode: 'percentage', showSteps: false },
  }
}
